module.exports = __webpack_public_path__ + "img/legend.30dd2fbc.png";